import { SB } from "@play-co/replicant";
const platformStorageSchema = SB.object({
  entry: SB.object({
    first: SB.int().min(0).optional(),
    last: SB.int().min(0),
    lastAdEntry: SB.int().min(0).optional(),
    lastResurrected: SB.int().min(0).optional()
  }),
  analytics: SB.object({
    $zeroEntryDatetime: SB.string().optional()
  }).optional()
});
function extendsPlatformStorage(platformStorage) {
  return !platformStorageSchema.validate(platformStorage, {
    ignoreUnexpectedFields: true
  });
}
function getEntryTimestamps(playerIds, getPlatformStorage) {
  const result = {};
  for (const id of playerIds) {
    const platformStorage = getPlatformStorage(id);
    const playerEntryTimestamps = getEntryTimestampsFromPlatformStorage(platformStorage);
    if (!playerEntryTimestamps) {
      continue;
    }
    result[id] = playerEntryTimestamps;
  }
  return result;
}
function getEntryTimestampsFromPlatformStorage(platformStorage) {
  if (!extendsPlatformStorage(platformStorage)) {
    return null;
  }
  const { entry, analytics } = platformStorage;
  if (entry.last === 0) {
    return null;
  }
  return {
    firstEntryAt: entry.first && entry.first !== 1545231968498 ? entry.first : void 0,
    lastEntryAt: entry.last,
    lastAdEntryAt: entry.lastAdEntry ? entry.lastAdEntry : void 0,
    lastResurrectedAt: entry.lastResurrected ? entry.lastResurrected : void 0,
    zeroEntryAt: (analytics == null ? void 0 : analytics.$zeroEntryDatetime) ? new Date(analytics.$zeroEntryDatetime).getTime() : void 0
  };
}
export {
  getEntryTimestamps,
  getEntryTimestampsFromPlatformStorage
};
